import { API } from '../../api'
import { chatServiceUrl } from '../../utils/constants'

/** A file the user attached to a stored turn (e.g. a funding SOW upload). */
export interface ChatHistoryAttachment {
  filename: string
  /** `s3://flyout-assets/<key>` — mapped to a public URL for the pill link. */
  s3_uri: string
  /** Inferred document kind (e.g. 'sow'); not currently surfaced in the UI. */
  doc_type?: string
}

/** A single stored message as returned by the v2 chat-history endpoint. */
export interface ChatHistoryMessage {
  event_id: string
  role: 'USER' | 'ASSISTANT'
  content: string
  /** ISO-8601, or '' when unknown. */
  timestamp: string
  /** Files attached to this turn; absent/empty when the turn has none. */
  attachments?: ChatHistoryAttachment[]
}

export interface ChatHistoryRequestBody {
  user_id: string
  session_id: string
  /** Page size, 1–100. Defaults to 20 server-side. */
  limit?: number
  /** Opaque cursor from the previous page. Omit/null for the first page. */
  next_token?: string | null
}

export interface ChatHistoryResponse {
  session_id: string
  /** Newest-first within the page (see endpoint docs). */
  messages: ChatHistoryMessage[]
  total_retrieved: number
  has_more: boolean
  next_token: string | null
}

/**
 * Read one page of a chat session's stored history. This is the same
 * conversation memory the agent reads/writes during `/chat/stream`, keyed by
 * partner + user + session. Pagination is cursor-based — echo `next_token` back
 * unchanged for the next page.
 */
export const getChatHistoryAPI = (
  partnerId: string,
  body: ChatHistoryRequestBody
) =>
  API.post<ChatHistoryResponse>(
    `${chatServiceUrl}/v2/partners/${partnerId}/chat/history`,
    body
  )
